/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled } from 'fierry/react.old';

import Center from 'galax/react/map/hex/center';
import * as Layer from 'galax/react/map/util/layer';


export default ({ containerRef, index, children, ...props }) =>
(
  <Layer.Placement containerRef = {containerRef} index = {index} >

    <Center {...props} >
      {children}
    </Center>

  </Layer.Placement>
);
